import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CARRIERS = {
  health: "https://www.healthsherpa.com",
  life: "https://www.mutualofomaha.com",
  ethos: "https://www.ethoslife.com",
  medicare: "https://www.medicare.gov",
};

export const AGENCY = {
  brand: "WF Services",
  producer: "Deep Deep Singh",
  npn: "22309710",
  license: "4245112",
  line: "Licensed Independent Insurance Producer — Life, Accident & Health",
  state: "Indiana",
  expires: "02/28/2029",
  email: "goodhands@lifeagoodheath25.org",
  phone: "(930) 215-6832",
  phoneHref: "tel:+19302156832",
  disclosure:
    "Deep Deep Singh (NPN: 22309710, IN License #: 4245112) is a licensed independent insurance producer authorized to offer Life, Accident & Health insurance in the state of Indiana. Independent representative affiliated with World Financial Group (WFG) / WF Services.",
};

export const postLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const postContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const postBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);
export const getBlog = () => axios.get(`${API}/blog`).then((r) => r.data);
export const getPost = (slug) => axios.get(`${API}/blog/${slug}`).then((r) => r.data);
